module.exports = __webpack_public_path__ + "img/newicon1.05c75c57.svg";